export default __webpack_public_path__ + "static/media/igor-piquet.b3f7079f.jpg";